export default "__VITE_ASSET__E5NM8CFX__"